import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const OSButton = makeShortcode("OSButton");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Make sure exposures and feature flag calls are being sent to PostHog. You should see `}<inlineCode parentName="p">{`$feature_flag_called`}</inlineCode>{` events appear in the `}<strong parentName="p">{`Activity`}</strong>{` feed.`}</p>
    <OSButton variant="secondary" asLink className="my-2" size="sm" to="https://app.posthog.com/activity/explore" external mdxType="OSButton">
  Check for events in PostHog
    </OSButton>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      